"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interact = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const NPC_1 = require("../classes/NPC");
const definables_1 = require("definables");
const getInteractableEntityCollidable_1 = require("./getInteractableEntityCollidable");
const pianoWorldMenu_1 = require("../world-menus/pianoWorldMenu");
const interact = () => {
    const entityCollidable = (0, getInteractableEntityCollidable_1.getInteractableEntityCollidable)();
    if (entityCollidable !== null) {
        switch (entityCollidable.type) {
            case "npc": {
                const npcID = (0, pixel_pigeon_1.getEntityFieldValue)(entityCollidable.entityID, "npcID");
                if (typeof npcID !== "string") {
                    throw new Error("No NPC ID.");
                }
                const npc = (0, definables_1.getDefinable)(NPC_1.NPC, npcID);
                if (npc.hasDialogue() || npc.hasQuestGiver()) {
                    (0, pixel_pigeon_1.emitToSocketioServer)({
                        data: {
                            npcID,
                        },
                        event: "world/npc-interact",
                    });
                    return;
                }
                break;
            }
            case "piano": {
                const pianoID = (0, pixel_pigeon_1.getEntityFieldValue)(entityCollidable.entityID, "pianoID");
                if (typeof pianoID !== "string") {
                    throw new Error("No piano ID.");
                }
                pianoWorldMenu_1.pianoWorldMenu.open({});
                return;
            }
        }
    }
    (0, pixel_pigeon_1.emitToSocketioServer)({
        data: {},
        event: "legacy/action",
    });
};
exports.interact = interact;
